module.exports = __webpack_public_path__ + "static/media/SF-UI-Text-Light.8d7f8421.eot";